import { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Col, Row } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import SignInHook from './SignUpHook';
import './signup.css';

class Signup extends Component {
  state = {
    title: 'Registration',
    hideForm: true,
    memberID: ' ',
  };

  handleVerifyMemberId = () => {
    if (this.state.memberID.length >= 4) {
      this.setState({ hideForm: false });
    } else {
      // TODO Add Message Cannot be empty
      console.log('empty');
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
  };

  render() {
    const {
      title,
    } = this.state;

    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main className="container">
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <h1 className="page-title">{title}</h1>
          <div className="container-register">
            <Row>
              <Col lg="4">
                <div className="card">
                  <div className="card-header">
                    About
                  </div>
                  <div className="card-body">
                    <p>
                      Member contact details and bio data enable you as a member
                      to register your self to NSSF Member Self Service Portal.
                    </p>
                    <p>
                      Once you complete registration. An email with activation
                      link and login details will be sent to your email shortly.
                      Follow instructions indicated in the email to register
                      your user account for NSSF Member Self Service Portal.
                    </p>
                    <p><b>Have account? Click button below</b></p>
                    <Link to="/login" className="btn btn-green btn-block px-4 gap-3">
                      Login
                    </Link>
                  </div>
                </div>
              </Col>
              <Col lg="8">
                <div className="card">
                  <div className="card-header">
                    FORM
                  </div>
                  <div className="card-body">
                    <SignInHook/>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </main>
      </>
    );
  }
}

export default Signup;
